export function count<T>(arr: T[], item: T) {
  return arr.filter((i) => i === item).length
}

export function unique<T>(arr: T[]) {
  return [...new Set(arr)]
}
